module.exports = __webpack_public_path__ + "static/media/bru1.17470fb1.jpeg";